<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Бренды"
    >
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="brandsData"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #top>
          <v-toolbar flat>
            <v-dialog v-model="dialog">
              <template #activator="{ on, attrs }">
                <v-btn
                  color="red"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Новая запись
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Добавление бренда</span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col sm="12">
                      <v-text-field
                        v-model="editedItem.name"
                        label="Название"
                      />
                      <v-text-field
                        v-model="editedItem.description"
                        label="Описание"
                      />
                      <v-select
                        v-model="editedItem.status"
                        :items="statusList"
                        label="Статус"
                        single-line
                      />
                      <p>Лого</p>
                      <file-input :value="editedItem.logo" bucket="image" :medias="[]" :show-media="false" :single-mode="false" @change="setLogo" />
                      <p>Баннер</p>
                      <file-input :value="editedItem.banner" bucket="image" :medias="[]" :show-media="false" :single-mode="false" @change="setBanner" />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Отмена
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save">
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template #item.actions="{ item }">
          <div class="d-flex">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-dialog
              transition="dialog-bottom-transition"
              width="500"
              :value="deleteDialog === item.id"
              @input="toggleDeleteDialog($event, item.id)"
            >
              <template #activator="{ on, attrs }">
                <v-tooltip top>
                  <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                    <span v-bind="tooltipAttrs" v-on="tooltipActions">
                      <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                        mdi-delete
                      </v-icon>
                    </span>
                  </template>
                  Удалить
                </v-tooltip>
              </template>
              <v-card>
                <v-toolbar color="primary" dark class="text-center mb-6">
                  Подтвердите Действие
                </v-toolbar>
                <v-card-text>
                  Вы точно хотите удалить бренд "{{ item.name }}"?
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn color="tertiary" dark @click="deleteDialog = null">
                    Отменить
                  </v-btn>
                  <v-btn color="primary" @click="deleteItem(item.id)">
                    Удалить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <template #item.logo="{ item }">
          <v-img
            width="200px"
            height="200px"
            contain
            :src="`${getLogo(item)}`"
          />
        </template>
        <template #item.banner="{ item }">
          <v-img
            width="200px"
            height="200px"
            contain
            :src="`${getBanner(item)}`"
          />
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { startCase } from 'lodash-es'
import { createBrand, deleteBrand, getBrands, updateBrand } from '@/graphql/brands'
import FileInput from '~/components/banners/FileInput'

export default {
  name: 'Banners',
  components: {
    FileInput
  },
  layout: 'dashboard',
  apollo: {
    getBrands: {
      query: getBrands,
      variables () {
        return this.getBrandsQueryVariables()
      },
      update (data) {
        return data.getBrands.data
      },
      result ({ data }) {
        this.totalCount = data.getBrands.count
      }
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      totalCount: 0,
      selectedCategory: null,
      deleteDialog: false,
      dialog: false,
      newItem: true,
      parentSlug: 'press',
      editedItem: {
        logo: [],
        banner: []
      },
      statusList: [
        { value: 'active', text: 'Активно' },
        { value: 'disable', text: 'Не активно' }
      ],
      statusListConverter: { 1: 'ACTIVE', 0: 'DISABLE' },
      headers: [
        ['id', 'Id'],
        ['name', 'Название'],
        ['logo', 'Лого'],
        ['banner', 'Баннер'],
        ['description', 'Описание'],
        ['status', 'Статус'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          })
    }
  },
  computed: {
    brandsData () {
      return this.getBrands ?? []
    }
  },
  watch: {
    selectedCategory () {
      this.options.page = 1
    },
    dialog (val) {
      if (val) {
        if (this.newItem) {
          this.clearEditedData()
        }
      } else {
        this.newItem = true
      }
    }
  },
  methods: {
    getDescriptionForList (item) {
      return item.description.join(' ')
    },
    getBrandsQueryVariables () {
      return {
        search: [],
        limit: this.options.itemsPerPage,
        offset: this.options.itemsPerPage * (this.options.page - 1)
      }
    },
    setLogo (images) {
      this.editedItem.logo = images
    },
    setBanner (images) {
      this.editedItem.banner = images
    },
    getLogo (item) {
      if (item.logo) {
        return item.logo.file?.url
      } else {
        return ''
      }
    },
    getBanner (item) {
      if (item.banner) {
        return item.banner.file?.url
      } else {
        return ''
      }
    },
    editItem (item) {
      this.newItem = false
      this.editedItem = Object.assign({}, item)
      this.editedItem.logo = [item.logo]
      this.editedItem.banner = [item.banner]
      this.dialog = true
    },
    save () {
      if (this.newItem) {
        this.$apollo
            .mutate({
              mutation: createBrand,
              variables: {
                input: {
                  name: this.editedItem.name,
                  description: this.editedItem.description,
                  status: this.editedItem.status,
                  logo: this.editedItem?.logo?.length > 0 ? { key: this.editedItem.logo[0].file.key, alt: this.editedItem.logo[0].alt } : {},
                  banner: this.editedItem?.banner?.length > 0 ? { key: this.editedItem.banner[0].file.key, alt: this.editedItem.banner[0].alt } : {}
                }
              }
            })
            .then((data) => {
              this.$apollo.queries.getBrands.refetch()
            })
            .catch((error) => {
              console.error(error)
            })
      } else {
        const id = this.editedItem.id
        this.$apollo
            .mutate({
              mutation: updateBrand,
              variables: {
                id,
                input: {
                  name: this.editedItem.name,
                  description: this.editedItem.description,
                  status: this.editedItem.status,
                  logo: this.editedItem.logo.length > 0 ? { key: this.editedItem.logo[0].file.key, alt: this.editedItem.logo[0].alt } : {},
                  banner: this.editedItem.banner.length > 0 ? { key: this.editedItem.banner[0].file.key, alt: this.editedItem.banner[0].alt } : {}
                }
              }
            })
            .then((data) => {
              this.$apollo.queries.getBrands.refetch()
            })
            .catch((error) => {
              console.error(error)
            })
      }
      this.close()
    },
    close () {
      this.newItem = true
      this.clearEditedData()
      this.dialog = false
    },
    clearEditedData () {
      this.editedItem = Object.assign({ logo: [], banner: [] })
      this.editedItem.logo = Object.assign([])
      this.editedItem.banner = Object.assign([])
    },
    deleteItem (id) {
      this.$apollo
          .mutate({
            mutation: deleteBrand,
            variables: {
              id
            }
          })
          .then((data) => {
            this.$apollo.queries.getBrands.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    }
  }
}
</script>

<style scoped>

</style>
